import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=31ef1786&"
import script from "./UserDropdown.vue?vue&type=script&lang=ts&"
export * from "./UserDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports